import {ConfigStructure} from "../config-structure.model";

export class MuseumObjectDetailsConfig {

  museumObjectDetailsConfig: ConfigStructure[];

}
